import { IA_POLITICS } from 'app/config/config';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import React from 'react';

const AIPolitics = () => {
  return (
    <div>
      <PdfViewerFullScreen url={IA_POLITICS.es} />
    </div>
  );
};

export default AIPolitics;
